import { SimpleGrid, Text, VStack } from "@chakra-ui/react";
import React from "react";

const NoResults = ({
  items,
  title,
  emptyMessage,
  emptyMessageLink,
  mapFunction,
  columns,
  isSearch,
}: any) => {
  return (
    <>
      {items?.length === 0 ? (
        <VStack alignItems="flex-start">
          <Text color="#4A5568" fontSize="14px">
            {title}
          </Text>

          <VStack alignItems="center">
            <Text
              textAlign="center"
              color="#171923"
              fontSize="14px"
              fontWeight="600"
            >
              {emptyMessage}
            </Text>
            <Text textAlign="center" color="#171923" fontSize="14px">
              {emptyMessageLink}
            </Text>
          </VStack>
        </VStack>
      ) : (
        <>
          <VStack alignItems="flex-start">
            <Text
              color="#4A5568"
              fontSize="14px"
              pb={isSearch ? "16px" : "20px"}
            >
              {title}
            </Text>
            {items ? (
              <>
                <SimpleGrid columns={columns} gap={isSearch ? 2 : 4}>
                  {items?.map(mapFunction)}
                </SimpleGrid>
              </>
            ) : (
              <>{items?.map(mapFunction)}</>
            )}
          </VStack>
        </>
      )}
    </>
  );
};

export default NoResults;
